import axios from 'axios';
import { notifyRequestTimeout } from './toastBridge';

// Axios has no default timeout, so a dead/slow backend hangs requests
// forever instead of ever producing a timeout error. Give every request
// a ceiling so a real timeout can actually occur and be surfaced.
const DEFAULT_TIMEOUT_MS = 20000;

const isTimeoutError = (error) =>
  error?.code === 'ECONNABORTED' && /timeout/i.test(error?.message || '');

export const installTimeoutInterceptor = (instance = axios) => {
  if (!instance.defaults.timeout) {
    instance.defaults.timeout = DEFAULT_TIMEOUT_MS;
  }
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (isTimeoutError(error)) {
        notifyRequestTimeout(error.config?.url);
      }
      return Promise.reject(error);
    }
  );
};

// Installed on the shared default axios instance immediately — every file
// that does `import axios from 'axios'` shares this same singleton, so this
// one call covers every raw axios.get/post/... call in the app.
installTimeoutInterceptor(axios);
